export const CUSTOMER_ELIGIBILITY = '/customers/eligibility-check';

export const CANDIDATE_PROFILES_SEARCH = '/candidate-profiles/search';

export const CANDIDATE_PROFILE = '/candidate-profiles';

// Contact/mark as hired features
export const HIRE_CANDIDATE = '/customers/hired-candidates';
export const HIRE_CANDIDATE_MAIL = '/customers/hired-candidates/email';
export const HIRE_CANDIDATE_PHONE = '/customers/hired-candidates/phone';

// Favoriting features
export const FAVORITE_CANDIDATE = '/customers/favorite-candidates';

// Reporting Content
export const REPORT_CONTENT = 'reports/candidate-profiles';

export const CANDIDATES_METADATA = '/candidates/metadata';
// Job Postings features
export const JOB_POSTINGS = 'job-postings';
// Location service
export const LOCATION_SERVICE = '/locations';
// enrollment service
export const ENROLLMENT_SERVICE = '/customers/enrollment';
